import { __require as requireFaXmark } from "../external/@fortawesome/free-solid-svg-icons/faXmark.es.js";
var faXmarkExports = /* @__PURE__ */ requireFaXmark();
export {
  faXmarkExports as f
};
//# sourceMappingURL=faXmark.es.js.map
